import { css } from "lit";

export const styles = css`
  .recent-message-banner {
    display: flex;
    background: var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-size-radius-400);
    overflow: hidden;
  }

  .banner-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--sds-size-space-1200);
    padding: var(--sds-size-space-600);
    flex: 1;
    min-width: 0;
  }

  .banner-header h3 {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    margin: 0;
    color: var(--sds-color-text-default-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .banner-preview {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .banner-bottom {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--sds-size-space-800);
  }

  .banner-info {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-600);
    flex: 1 0 0;
    min-width: 0;
  }

  .banner-date-row {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
  }

  .banner-date {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    white-space: nowrap;
  }

  .banner-stats {
    display: flex;
    gap: var(--sds-size-space-600);
  }

  .banner-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--sds-size-space-100);
  }

  .stat-label {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
  }

  .stat-value {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-primary);
  }

  .banner-actions {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    margin-left: auto;
  }

  @media (max-width: 900px) {
    .banner-content {
      gap: var(--sds-size-space-800);
    }

    .banner-bottom {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--sds-size-space-800);
    }

    .banner-info {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--sds-size-space-400);
      width: 100%;
      min-width: 0;
    }

    .banner-stats {
      width: 100%;
    }

    .stat-label {
      white-space: nowrap;
    }

    .banner-actions {
      width: 100%;
      gap: var(--sds-size-space-400);
    }

    .banner-actions > wow-button:first-child {
      flex: 1;
      --wow-button-width: 100%;
      --wow-button-inner-width: 100%;
    }
  }
`;
